import { render, staticRenderFns } from "./Instituciones.vue?vue&type=template&id=753a9f87&"
import script from "./Instituciones.vue?vue&type=script&lang=js&"
export * from "./Instituciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports